// Module
var code = "<template> <section class=\"card card-template\"> <header class=\"header ${borderClass}\"> <slot name=\"header\"></slot> </header> <div class=\"content\"> <slot name=\"content\"></slot> </div> </section> </template> ";
// Exports
export default code;